import type { SVGProps } from 'react';

export function BankIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#clip0_7383_10025)">
        <path
          d="M2.66634 7.66622V10.3329C2.66634 10.8862 3.11301 11.3329 3.66634 11.3329C4.21967 11.3329 4.66634 10.8862 4.66634 10.3329V7.66622C4.66634 7.11289 4.21967 6.66622 3.66634 6.66622C3.11301 6.66622 2.66634 7.11289 2.66634 7.66622ZM6.66634 7.66622V10.3329C6.66634 10.8862 7.11301 11.3329 7.66634 11.3329C8.21967 11.3329 8.66634 10.8862 8.66634 10.3329V7.66622C8.66634 7.11289 8.21967 6.66622 7.66634 6.66622C7.11301 6.66622 6.66634 7.11289 6.66634 7.66622ZM2.33301 14.6662H12.9997C13.553 14.6662 13.9997 14.2196 13.9997 13.6662C13.9997 13.1129 13.553 12.6662 12.9997 12.6662H2.33301C1.77967 12.6662 1.33301 13.1129 1.33301 13.6662C1.33301 14.2196 1.77967 14.6662 2.33301 14.6662ZM10.6663 7.66622V10.3329C10.6663 10.8862 11.113 11.3329 11.6663 11.3329C12.2197 11.3329 12.6663 10.8862 12.6663 10.3329V7.66622C12.6663 7.11289 12.2197 6.66622 11.6663 6.66622C11.113 6.66622 10.6663 7.11289 10.6663 7.66622ZM7.04634 0.992891L1.77967 3.76622C1.50634 3.90622 1.33301 4.19289 1.33301 4.49956C1.33301 4.95956 1.70634 5.33289 2.16634 5.33289H13.173C13.6263 5.33289 13.9997 4.95956 13.9997 4.49956C13.9997 4.19289 13.8263 3.90622 13.553 3.76622L8.28634 0.992891C7.89967 0.786224 7.43301 0.786224 7.04634 0.992891Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7383_10025">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
